<div #addressVerificationTooltip class="address-verification-tooltip">
  <div class="address-verification-tooltip__title">Current Status</div>
  <hr class="my-2 w-full" />
  <div>{{ verificationStatus }}</div>
</div>

<svg width="16" height="16" viewBox="0 0 16 16">
  <g id="Group_554" data-name="Group 554" transform="translate(-17 -7)">
    <circle
      id="Ellipse_105"
      data-name="Ellipse 105"
      cx="8"
      cy="8"
      r="8"
      transform="translate(17 7)"
      [attr.fill]="iconColor"
      (mouseenter)="onMouseEnter(addressVerificationTooltip)"
      (mouseleave)="onMouseLeave(addressVerificationTooltip)"
    />
    <path
      id="Path_338"
      data-name="Path 338"
      d="M21.125,14.563l2.548,2.548,5.179-5.376"
      transform="translate(0 1)"
      fill="none"
      stroke="#fff"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    />
  </g>
</svg>
